module.exports = __webpack_public_path__ + "img/logo.87dba642.png";